import {getFarmCadastre} from '../../services/hookService/getCadastreData';
import {getLoanScoreFactores} from '../../services/hookService/getLoanScoreFactores';
import {getLoanValidationResult} from '../../services/hookService/getLoanValidationResult/getLoanValidationResult';

import FarmCreditReportPdfDocument from './components/Document';
import {formatFarmData, formatScoreFactores} from './utils/formatData';
import {generatePdfFile} from './utils/generatePdfFile';
import generateSerialNumber from './utils/generateSerialNumber';
import {openAndDownloadPdf} from './utils/openAndDownloadPdfDocument';

interface HandleDownloadParams {
  guid: string;
  uploadPdf: (params: {loanGuid: string; formData: File}) => Promise<unknown>;
}

export default async function handleDownload({
  guid,
  uploadPdf,
}: HandleDownloadParams) {
  const [validationResult, scoreFactors, cadastre] = await Promise.all([
    getLoanValidationResult(guid),
    getLoanScoreFactores(guid),
    getFarmCadastre(guid),
  ]);

  const document = (
    <FarmCreditReportPdfDocument
      serialNumber={generateSerialNumber()}
      riskGrade={validationResult.loan_validation_letter}
      riskGaugeScore={validationResult.overall_score}
      scoreFactorsData={formatScoreFactores(scoreFactors)}
      farms={cadastre.map(formatFarmData)}
    />
  );

  const pdfFile = await generatePdfFile(document);

  await openAndDownloadPdf(document);

  await uploadPdf({
    loanGuid: guid,
    formData: pdfFile,
  });
}
